import { DateFields } from '../../../../common/DateFields';
import { MaintenanceRecordCreate } from '../../../../../types/api';

interface MaintenanceDateFieldsProps {
  record: MaintenanceRecordCreate;
  onFieldChange: (field: keyof MaintenanceRecordCreate, value: string) => void;
}

export const MaintenanceDateFields: React.FC<MaintenanceDateFieldsProps> = ({
  record,
  onFieldChange,
}) => {
  return (
    <DateFields
      mode="range"
      startValue={record.start_date || ''}
      endValue={record.end_date || ''}
      onStartChange={(value) => onFieldChange('start_date', value)}
      onEndChange={(value) => onFieldChange('end_date', value)}
      startLabel="Start Date"
      endLabel="End Date"
      startHelperText="Date when maintenance started"
      endHelperText="Date when maintenance completed"
      autoAdjustDates={true}
    />
  );
};
